// 品牌风险排行筛选逻辑（从 Overview.tsx 抽出为独立模块，满足 react-refresh/only-export-components，
// 并便于 vitest 纯逻辑测试）。0 后端 / 0 数据改：仅客户端 re-sort + 标签口径常量。

// 4 个筛选维度（tab）→ 排序字段映射：
// 综合风险/投诉/召回 = 越大越高风险 → desc；
// 情绪 = sentiment_score 极性分(~[-1,1]，越负越差，metrics.py:507/516 锚) → 越负风险越高 → asc。
export const RISK_DIMENSIONS = ['综合风险', '投诉', '召回', '情绪'] as const;
export type RiskDimension = (typeof RISK_DIMENSIONS)[number];

// 召回数字口径 = recall_count_ytd（YTD 年内累计，非本周；与右「本周召回事件」W25 窗区分）。
export const RECALL_YTD_LABEL = '召回·年内';
export const RECALL_YTD_TOOLTIP = 'YTD 年内累计，非本周（与「本周召回事件」口径不同）';
// 投诉数字口径 = complaint_count_7d（近 7 日）。
export const COMPLAINT_7D_HINT = '近7日';

export interface RiskSortable {
  risk_score: number;
  complaint_count_7d: number;
  recall_count_ytd: number;
  sentiment_score: number;
}

/** 纯函数：按所选维度对 brand_risk 客户端 re-sort（不增删、不改值、不 mutate 入参）。 */
export function sortByRiskDimension<T extends RiskSortable>(items: T[], dim: RiskDimension): T[] {
  const copy = [...items];
  switch (dim) {
    case '投诉':
      return copy.sort((a, b) => b.complaint_count_7d - a.complaint_count_7d);
    case '召回':
      return copy.sort((a, b) => b.recall_count_ytd - a.recall_count_ytd);
    case '情绪':
      return copy.sort((a, b) => a.sentiment_score - b.sentiment_score); // 越负=风险越高 → asc
    case '综合风险':
    default:
      return copy.sort((a, b) => b.risk_score - a.risk_score);
  }
}
